import { getOperation } from "utils/api";

export const queryPayfac = async (params) => {
  return await getOperation("/payfac", {
    sort: "created,DESC",
    ...params,
  });
};
